import { Tolgee, DevTools, FormatSimple } from '@tolgee/web';
import { I18nextPlugin } from '@tolgee/i18next';

const tolgeeApiUrl = import.meta.env.VITE_TOLGEE_API_URL;
const tolgeeApiKey = import.meta.env.VITE_TOLGEE_API_KEY;

const tolgeeBuilder = Tolgee()
  .use(FormatSimple())
  .use(I18nextPlugin());

// Only enable DevTools (which adds _tolgee attributes to DOM) when
// a Tolgee API key is configured for in-context editing.
// Without this guard, DevTools wraps every translated string and breaks
// Playwright strict-mode selectors.
if (tolgeeApiUrl && tolgeeApiKey) {
  tolgeeBuilder.use(DevTools());
}

export const tolgee = tolgeeBuilder.init({
  language: 'en',
  availableLanguages: ['en', 'sv', 'es'],
  defaultLanguage: 'en',

  // Connect to Tolgee server only when API key is configured.
  // Without a key, the app falls back to local JSON files via i18next-http-backend.
  ...(tolgeeApiUrl && tolgeeApiKey
    ? {
        apiUrl: tolgeeApiUrl,
        apiKey: tolgeeApiKey,
      }
    : {}),
});
